export default __webpack_public_path__ + "static/media/award-end-line.85b8161c.svg";